export const cartCustomProp = 'shoppingDetails.cart';

export const cartSGroups = ['cart_read', 'cart_read_cart_product', 'cart_product_read', 'cart_product_read_product', 
'product_read',
'product_read_product_image',
'app_file_read',
'product_read_product_prices',
'product_price_read',
'created_date'
]